var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "login" }, [
    _c(
      "div",
      { staticClass: "login-con" },
      [
        _c(
          "Card",
          {
            staticStyle: { "background-color": "white" },
            attrs: {
              bordered: false,
              icon: "log-in",
              title: "种苗网 欢迎登录",
            },
          },
          [
            _c("div", { staticClass: "form-con" }, [
              _c(
                "div",
                {
                  staticStyle: {
                    width: "276px",
                    float: "left",
                    "text-align": "center",
                  },
                },
                [
                  _c("img", {
                    key: "max-logo",
                    staticStyle: { width: "276px", height: "89px" },
                    attrs: { src: _vm.maxLogo },
                  }),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "text-align": "center",
                        "font-size": "24px",
                        color: "rgb(0, 153, 0)",
                      },
                    },
                    [_vm._v("缤纷种苗网上销售平台")]
                  ),
                ]
              ),
              _c(
                "div",
                { staticStyle: { width: "250px", float: "right" } },
                [
                  _c("login-form", {
                    attrs: { loading: _vm.submitBtnLoading },
                    on: { "on-success-valid": _vm.handleSubmit },
                  }),
                ],
                1
              ),
            ]),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }